import { Component, OnInit } from '@angular/core';
import { BroadcastSearchControllerService } from 'src/app/rest-proxy/api/api';
import { NotificationLabelEN } from 'src/app/models/labels/notificationLabel_EN';
import { LoginRenderingService } from 'src/app/services/login/login-rendering.service';

//import {WebSocketService} from "../../websocket.service";



@Component({
  selector: 'app-broadcast-message',
  templateUrl: './broadcast-message.component.html',
  styleUrls: ['./broadcast-message.component.scss']
})
export class BroadcastMessageComponent implements OnInit {
  public receivedMessages: string[] = [];
  private stompClient: any;
  private showGreeting: any;
  letcurr:Array<string>=[];
  messages = [];
  label: NotificationLabelEN;
  constructor(private service_call: BroadcastSearchControllerService,loginService: LoginRenderingService) {
    let currentUser = loginService.currentUser;

    // this.letcurr.push(JSON.parse(localStorage.getItem('currentUser')).userId);
       this.letcurr.push(currentUser.userId);

   
    service_call.fetchBroadcastNotificationUsingPOST(this.letcurr).subscribe(data => {
     console.log(data);
    this.messages=data;
   })
  }


  ngOnInit() {
    this.label = new NotificationLabelEN();
    var obj = JSON.parse(window.localStorage.currentUser);
    let value = [];
    value.push(obj.userId);

  }
  clearall() {
    this.messages=[];
  }
  remove(value) {
    console.log("removed value is ",this.messages[value]);
    this.messages.splice(value,1);
  }
  more(value) {
    (<HTMLInputElement>document.getElementById(value)).style.height = "10rem !important";
  }

}
